import { Trans } from 'next-i18next';
import React from 'react';
import { BasicLink } from '@components/buttons/BasicLink/BasicLink.component';
import { PlcImg } from '@components/PlcImg/PlcImg.component';
import { Text } from '@components/Text/Text.component';
import { Breakpoint, useBreakpoint } from '@styles/breakpoints';
import { isMobileDevice } from '@utils/navigation';
import { urlEnum } from '@utils/url';
import { useWebview } from '@utils/webview.hook';
import styles from './CASectionPopUp.module.scss';

interface Props {
  is15Days?: boolean;
}

const CASectionPopUp = ({ is15Days = false }: Props) => {
  const breakpoint = useBreakpoint();
  const isMobileDisplay = breakpoint < Breakpoint.s;
  const isWebview = useWebview();

  function renderRedirectSubscriptionPro() {
    if (isWebview && isMobileDevice(null, 'ios')) {
      return (
        <Text
          className="plc-mt-s"
          flavour="light"
          i18nKey="actu.become-pro-subscribe.redirection"
          variant={isMobileDisplay ? 'h6' : 'h5'}
        />
      );
    }
    return (
      <BasicLink
        as={is15Days ? urlEnum.abonnementPro : urlEnum.proSavoirPlus}
        href={is15Days ? urlEnum.abonnementPro : urlEnum.proSavoirPlus}
        isUnderlined
        textProps={{
          flavour: 'light',
          i18nKey: 'common.pro.savoir.plus',
          variant: isMobileDisplay ? 'h5' : 'h4',
        }}
      />
    );
  }

  return (
    <section className={`${styles['ca-sectionPopUp']} plc-mt-l`}>
      <div className={styles['flex-logo']}>
        <PlcImg alt="" plcSrc={{ src: 'ca-logo', type: 'local' }} width={isMobileDisplay ? 35 : 50} />
      </div>

      <div className={styles['flex-texte']}>
        <Text flavour="light" i18nKey="landing.pop-up.ca-title" variant={isMobileDisplay ? 'h5' : 'h4'} />
        <Text flavour="light" variant="p">
          <Trans i18nKey="landing.ca-content" ns="landing">
            <Text flavour="yellow" tag="span" variant="p" />
          </Trans>
        </Text>
        {renderRedirectSubscriptionPro()}
      </div>
    </section>
  );
};

export { CASectionPopUp };
